<template>
    <div class="error403">
        <Header :isShowUser='false'></Header>
        <errorItem :data="data"
                   :noSHowDashboard="true">
            <img src="@/assets/images/403_03.jpg">
        </errorItem>
    </div>
</template>

<script>
import errorItem from '@/views/components/basic/erroritem'
import Header from '@/views/components/portal/header.vue'
export default {
    name: 'Error403',
    data () {
        return {
            data: {
                ms: '抱歉，无法访问此网页...',
                ts: '请检查访问地址是否正常或是否具有权限访问等!'
            }
        }
    },
    components: { errorItem, Header }
}
</script>
<style lang="less">
</style>
